import React from "react";
import {
  MdElectricBolt,
  MdOutlineLocalFireDepartment,
  MdEnergySavingsLeaf,
} from "react-icons/md";
import StepShell from "./StepShell";
import copy from "../copy";

const ICONS = {
  Luz: <MdElectricBolt />,
  Gas: <MdOutlineLocalFireDepartment />,
  "Luz + Gas": <MdEnergySavingsLeaf />,
};

const EnergyStep = ({ value, onSelect }) => {
  const c = copy.energy;
  return (
    <StepShell title={c.title} subtitle={c.subtitle}>
      <p className="rp-lead">{c.lead}</p>
      <h2 className="rp-question">{c.question}</h2>
      <div className="rp-cards" role="group" aria-label={c.question}>
        {c.options.map((option) => (
          <button
            key={option}
            type="button"
            className={`rp-card${value === option ? " is-selected" : ""}`}
            aria-pressed={value === option}
            onClick={() => onSelect(option)}
          >
            <span className="rp-card__icon" aria-hidden="true">
              {ICONS[option]}
            </span>
            <span className="rp-card__label">{option}</span>
          </button>
        ))}
      </div>
    </StepShell>
  );
};

export default EnergyStep;
